import { getRequest } from '../services/requestHandler';
import { HeadWeightNumber } from '../models';

export const getHeadWeightNumbers = async () => {
  const url = 'headWeight/getHeadWeightNumbers?useCache=false';
  const response = await getRequest<HeadWeightNumber>('GetHeadWeightNumbers', url);
  // TODO: Remove this from here and implement uuid
  let autoId = 0;
  let numbers = response.map((r) => {
    return { ...r, headWeightNumberId: autoId++ };
  });
  return numbers;
};
